import React from 'react';
import GridColCard from '../CdtGridColCard';
import { BsEye } from 'react-icons/bs';
import { P } from '../Typography/styles';
import { CdtListByColContainer, CdtListByGridContent, CdtListByGridHeadTitle, CdtListByGridHeadTitleSpan, CdtListByGridShowMore, CdtListByGridShowMoreButton, 
  Tooltip,
  TooltipTitle,
  TooltipContent,
  InfoCircleImage } from './styles';
import colors from '../../assets/styles/colors';
import infoCircle from '../../assets/images/info-circle.svg';
import { tooltipSolicitudes } from '../../helpers/enum';

const CdtListByCol = ({  item, search, showBy, getFilteredSolicitationsBylabel, getLengthOfFilteredSolicitationsBylabel, getLengthOfSolicitationsBylabel, setLimitToStatus, canalEstado, setShowModalAnular, setIdCreditAnular }) => {
  return (
    <CdtListByColContainer id="list-by-col">
      <CdtListByGridHeadTitle>
        <P bold color={colors.textPrimary}>{item.label}
          {canalEstado == "abacus" && tooltipSolicitudes[item.label] && (
          <InfoCircleImage src={infoCircle} alt="info" data-tip data-for={item.label}/>
          )}
        </P>
        <CdtListByGridHeadTitleSpan>(
          {search !== '' || showBy !== 'Todos' ? getLengthOfFilteredSolicitationsBylabel(item.label) : getLengthOfSolicitationsBylabel(item.label)}
        )</CdtListByGridHeadTitleSpan>
        </CdtListByGridHeadTitle>
      <CdtListByGridContent>
        {getFilteredSolicitationsBylabel(item.label).slice(0, item.limit).map((solicitation, solicitationKey) => (
          <GridColCard key={solicitationKey} item={solicitation} canalEstado={canalEstado} setShowModalAnular={setShowModalAnular} setIdCreditAnular={setIdCreditAnular} />
        ))}
      </CdtListByGridContent>
      <CdtListByGridShowMore>
        <CdtListByGridShowMoreButton onClick={() => setLimitToStatus(item)}>
          <BsEye id="eye-icon" /> Ver {item.limit > 3 ? "menos" : "más"}
        </CdtListByGridShowMoreButton>
      </CdtListByGridShowMore>
      {canalEstado == "abacus" && tooltipSolicitudes[item.label] && (
      <Tooltip 
        id={item.label}
        effect="solid"
        place='right'
        border
        multiline
        textColor='#05443D'
        borderColor='#25BBAB'>
        <TooltipTitle>
          {item.label}
        </TooltipTitle>
        <TooltipContent>
          {tooltipSolicitudes[item.label]}
        </TooltipContent>
      </Tooltip>
      )}
    </CdtListByColContainer>
  )
}

export default CdtListByCol;
